console.log('app is ready')